<template>
    <div class="modal fade show modal-style " aria-labelledby="cardTitle">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-items-center">
                            <h3 class="mb-0">Incomplete Forms</h3>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>
                <hr class="mt-0 mb-0">
                <div class="py-2 px-4">
                    <div class="alert alert-danger p-2 border border-danger" v-if="errorMessage && errorMessage !== ''">
                        {{ errorMessage }}
                    </div>
                    <p class="fw-bolder">
                        Please select 1 of the incomplete bill or click cancel to create new bill
                    </p>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="width-75-per">Form</th>
                                <th class="width-25-per">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="formKey in formKeyList">
                                <td class="width-75-per py-2">{{ formKey }}</td>
                                <td class="width-25-per text-center">
                                    <button
                                        class="btn btn-sm btn-outline-success text-nowrap px-1 button_icon"
                                        type="button"
                                        @click="getFormData(formKey)"
                                    >
                                        <i class="fa fa-play"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex gap-2 justify-content-end pb-1 px-2">
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-primary" type="button" @click="onCLickGo">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {useStore} from "vuex";
    import {useRoute, useRouter} from "vue-router";
    import {computed, ref} from "vue";
    import handlePurchase from "@/services/modules/purchase";

    const emit = defineEmits(['selectForm']);
    const props = defineProps({
        formKeyList : {
            default: [],
            type: Array
        }
    })
    const store = useStore();
    const $route = useRoute();
    const $router = useRouter();
    const errorMessage = ref('');

    const getFormData = async (selectedFormKey) => {
      await $router.push({
        query: {...$route.query, form_key: selectedFormKey}
      })

      emit('selectForm', selectedFormKey)
      onClickClose();
    }

    const onClickClose = () => {
        store.state.isModalOpen = false;
    }


    const onCLickGo = () => {
        onClickClose();
    }

</script>

<style scoped>
.modal-style {
    display: block;
    background: #1c1d1c33
}
</style>